import { Component, OnInit } from '@angular/core';
import { SearchFilterService } from '../../services/search-filter.service';
import { CollectionsService } from '../../../collections/service/collections.service';
import { ProductInterface } from '../../../products/interfaces/product.interface';
import i18next from 'i18next';
import { Router } from '@angular/router';
import { SelectColors } from '../../store/actions/filter.actions';
import { AnalyticsService } from 'src/core/services/analytics.service';

@Component({
  selector: 'app-search-filter',
  templateUrl: './search-filter.component.html',
  styleUrls: ['./search-filter.component.scss'],
})
export class SearchFilterComponent implements OnInit {
  value = '';

  constructor(
    private searchFilterService: SearchFilterService,
    private collectionsService: CollectionsService,
    private router: Router,
    private analyticsService: AnalyticsService
  ) {}

  ngOnInit(): void {
    this.searchFilterService.searchTerm$.subscribe((term) => {
      console.log(term);
      this.value = term;
    });
  }

  handleFilterOverlay(): void {
    this.searchFilterService.filterOpen = !this.searchFilterService.filterOpen;
    if (this.searchFilterService.filterOpen === true) {
      this.analyticsService.trackEvent({
        event: 'virtualpageview',
        category: 'bpl app',
        page: '/applic/bpl-app/virtual/show-filters',
      });
    }
    setTimeout(() => {
      window.dispatchEvent(new Event('resize'));
    }, 300);
  }

  setValue(searchValue: any): void {
    this.searchFilterService.searchTerm$.next(
      searchValue.value.replaceAll('-', '')
    );
  }

  search(): void {
    this.searchFilterService.searchResults$.next(
      Object.values(this.collectionsService.articlesData).filter(
        (product: ProductInterface) => {
          return (
            i18next
              .t(product.texts.title)
              .toLowerCase()
              .includes(
                this.searchFilterService.searchTerm$.getValue().toLowerCase()
              ) ||
            i18next
              .t(product.texts.headline)
              .toLowerCase()
              .includes(
                this.searchFilterService.searchTerm$.getValue().toLowerCase()
              ) ||
            product.sku
              .toString()
              .toLowerCase()
              .includes(
                this.searchFilterService.searchTerm$.getValue().toLowerCase()
              )
          );
        }
      )
    );
    console.log(this.searchFilterService.searchResults$.getValue());
    this.router.navigate(['/search']);
  }
}
